export default __webpack_public_path__ + "static/media/7.0c8fe161.jpg";